import { Component, Input } from '@angular/core';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { PipBaseStateComponent } from '../pip-base-state.component';
import { BaseRules, TextValues } from './nevada.model';
import { CoverageLimit, PersonalInjuryProtectionSelection } from '../../../config/pip-constants';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-nevada',
  templateUrl: './nevada.component.html',
  styleUrls: ['./nevada.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule
  ],
})
export class NevadaComponent extends PipBaseStateComponent<BaseRules, TextValues> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('nevada', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('nevada', null);
    }
  }
  override dynamicRuleQueryBuilder(): string {
    if (
      this.baseRulesService.personalInjuryProtectionSelection ===
        PersonalInjuryProtectionSelection.IndividualStateCoverage ||
      (this.baseRulesService.personalInjuryProtectionSelection ===
        PersonalInjuryProtectionSelection.AcceptCoverage &&
        this.baseRulesService.coverageLimit === CoverageLimit.VaryByState)
    ) {
      return 'ShowSelectAndReject';
    }
  }
  
}
